import { useCallback } from 'react';

import { useLocation } from 'react-router';

import { NotificationActionTypeEnum } from '@vk-hr-tek/core/notifications';
import { Box } from '@vk-hr-tek/ui/Box';
import { Link } from '@vk-hr-tek/ui/Link';
import { Typography } from '@vk-hr-tek/ui/Typography';
import { Icon } from '@vk-hr-tek/ui/Icon';

import { useStyles } from './Notifications.styles';

interface NotificationActionProps {
  text: string;
  link?: string;
  actionType: NotificationActionTypeEnum;
}

export const NotificationAction = ({
  link,
  actionType,
  text,
}: NotificationActionProps) => {
  const { classes } = useStyles();
  const { pathname } = useLocation();

  const renderIcon = useCallback((type: NotificationActionTypeEnum) => {
    switch (type) {
      case NotificationActionTypeEnum.Redirect:
        return <Icon name="error_circle_outline" size="24" />;

      case NotificationActionTypeEnum.Refresh:
        return <Icon name="refresh_outline" size="24" />;

      default:
        return null;
    }
  }, []);

  return (
    <Link variant="simple" to={link || pathname} stroke={false}>
      <Box
        p="16"
        display="flex"
        alignItems="center"
        className={classes.content}
        radius={['0', '0', 'l', 'l']}
        bgcolor="original.brand.primary"
      >
        {renderIcon(actionType)}

        <Box ml="16">
          <Typography variant="subtitle2" color="text.dark.primary">
            {text}
          </Typography>
        </Box>

        {link && (
          <Box ml="auto" height={24}>
            <Icon name="chevron_right_small_outline" size="24" />
          </Box>
        )}
      </Box>
    </Link>
  );
};
